import { render, staticRenderFns } from "./Miscellaneous.vue?vue&type=template&id=b4b29480&scoped=true&"
import script from "./Miscellaneous.vue?vue&type=script&lang=js&"
export * from "./Miscellaneous.vue?vue&type=script&lang=js&"
import style0 from "./Miscellaneous.vue?vue&type=style&index=0&id=b4b29480&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b29480",
  null
  
)

export default component.exports